export enum ExpressionTypeEnum {
  And = 'And',
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  In = 'In',
  NotIn = 'NotIn',
  Or = 'Or',
  Contains = 'Contains',
  DoesNotContain = 'DoesNotContain',
  StartsWith = 'StartsWith',
  DoesNotStartWith = 'DoesNotStartWith',
  Like = 'Like',
  IsNotLike = 'IsNotLike',
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
  Under = 'Under',
}

export enum FieldOperatorTypeEnum {
  Size = 'Size',
  Sum = 'Sum',
  Avg = 'Avg',
  Min = 'Min',
  Max = 'Max',
  First = 'First',
  Last = 'Last',
  Any = 'Any',
}

export const EXPRESSION_TYPE_LIST = [
  {
    type: ExpressionTypeEnum.Equal,
    label: { en: 'Equal', ar: 'يساوي' },
  },
  {
    type: ExpressionTypeEnum.NotEqual,
    label: { en: 'Not equal', ar: 'لا يساوي' },
  },
  {
    type: ExpressionTypeEnum.LessThan,
    label: { en: 'Less than', ar: 'أقل من' },
  },
  {
    type: ExpressionTypeEnum.LessThanOrEqual,
    label: { en: 'Less than or equal', ar: 'أقل من أو يساوي' },
  },
  {
    type: ExpressionTypeEnum.GreaterThan,
    label: { en: 'Greater than', ar: 'أكبر من' },
  },
  {
    type: ExpressionTypeEnum.GreaterThanOrEqual,
    label: { en: 'Greater than or equal', ar: 'أكبر من أو يساوي' },
  },
  {
    type: ExpressionTypeEnum.Contains,
    label: { en: 'Contains', ar: 'تحتوي' },
  },
  {
    type: ExpressionTypeEnum.DoesNotContain,
    label: { en: 'Does not contain', ar: 'لا تحتوي' },
  },
  {
    type: ExpressionTypeEnum.StartsWith,
    label: { en: 'Start with', ar: 'تبدأ ب' },
  },
  {
    type: ExpressionTypeEnum.DoesNotStartWith,
    label: { en: 'Does not start with', ar: 'لا تبدأ ب' },
  },
  {
    type: ExpressionTypeEnum.Like,
    label: { en: 'Like', ar: 'مثل' },
  },
  {
    type: ExpressionTypeEnum.IsNotLike,
    label: { en: 'Is not like', ar: 'ليست مثل' },
  },
  {
    type: ExpressionTypeEnum.In,
    label: { en: 'In', ar: 'في' },
  },
  {
    type: ExpressionTypeEnum.NotIn,
    label: { en: 'Not in', ar: 'ليست في' },
  },
  {
    type: ExpressionTypeEnum.IsEmpty,
    label: { en: 'Is empty', ar: 'فارغ' },
  },
  {
    type: ExpressionTypeEnum.IsNotEmpty,
    label: { en: 'Is filled', ar: 'مملوء' },
  },
  {
    type: ExpressionTypeEnum.Under,
    label: { en: 'Under', ar: 'أسفل' },
  },
];
